import React from 'react';
import { Autocomplete, TextField, Button, CircularProgress } from '@mui/material';

const ManualLocationSync = ({
  countries = [],
  locationDetails = { country: "", state: "", city: "" },
  onLocationChange,
  onUpdate,
  loading = false
}) => {
  return (
    <div style={{ width: '100%', padding: '20px' }}>
      <Autocomplete
        id="country-select"
        options={countries}
        getOptionLabel={(option) => option.name || ""}
        value={countries.find(country => country.name === locationDetails.country) || null}
        onChange={(event, newValue) => {
          onLocationChange({
            ...locationDetails,
            country: newValue ? newValue.name : ""
          });
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select Country"
            variant="standard"
            required
          />
        )}
      />
      <TextField
        id="state-input"
        variant="standard"
        label="State"
        value={locationDetails.state}
        onChange={(event) => {
          const value = event.target.value;
          onLocationChange({
            ...locationDetails,
            state: value
          });
        }}
        style={{ marginTop: '16px', marginBottom: '12px', marginRight: '30px' }}
      />
      <TextField
        id="city-input"
        variant="standard"
        label="City"
        value={locationDetails.city}
        onChange={(event) => {
          const value = event.target.value;
          onLocationChange({
            ...locationDetails,
            city: value
          });
        }}
        style={{ marginTop: '16px', marginBottom: '12px' }}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={onUpdate}
        disabled={!locationDetails.country || loading}
        style={{ marginTop: '16px', width: '100%' }}
      >
        {loading ? (
          <CircularProgress size={20} style={{ color: 'white', marginRight: 8 }} />
        ) : null}
        {loading ? "Updating..." : "Update Location"}
      </Button>
    </div>
  );
};

export default ManualLocationSync;

